import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Link } from './Footer.styles';

type FooterProps = {};

const Footer: React.FC<FooterProps> = () => {
  return (
    <Box
      width='100%'
      display='flex'
      flexDirection={{
        xs: 'column-reverse',
        sm: 'row',
      }}
      justifyContent='space-evenly'
      alignItems='center'
      my={10}
    >
      <Box display='flex' flexDirection='column' gap={2}>
        <Typography
          fontSize='16px'
          fontWeight={400}
          lineHeight='24px'
          mt={{ xs: 5, sm: 0 }}
          px={{ xs: 2, sm: 0 }}
          textAlign={{
            xs: 'center',
            sm: 'left',
          }}
        >
          We can't wait to help you reach your full potential with Go2 Career
          Path!
        </Typography>
        <Typography
          fontSize='11px'
          fontWeight={500}
          lineHeight='16px'
          textAlign={{
            xs: 'center',
            sm: 'left',
          }}
        >
          (c) Go2. All rights reserved.
        </Typography>
      </Box>
      <Box display='flex' gap={5}>
        <Box display='flex' flexDirection='column' gap={2}>
          {/* <Typography
            fontSize='14px'
            fontWeight={600}
            lineHeight='20px'
            gutterBottom
          >
            Link Category
          </Typography> */}
          <Link href='https://www.go2.io/privacy-policy'>Privacy Policy</Link>
          <Link href='https://support.go2.io/en/articles/7173360-terms-of-service'>
            Terms of Service
          </Link>
        </Box>
        <Box display='flex' flexDirection='column' gap={2}>
          {/* <Typography
            fontSize='14px'
            fontWeight={600}
            lineHeight='20px'
            gutterBottom
          >
            Link Category
          </Typography> */}
          <Link href='https://support.go2.io/en/collections/3513429-about-go2'>
            About
          </Link>
          <Link href='https://support.go2.io'>Help</Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
